import React, { Component } from 'react';
import * as THREE from 'three';


/**
 *  width, height - canvas width, height
 *  top, left - canvas top, left
 *  zIndex - canvas zIndex
 * 
 *  textureUrl
 *  framwWidth framwHeight
 * 
 *  textureX, textureY - где находится текстура
 *  nowFrame
 * 
 */

export class SnowParticles extends Component {

    uId = Math.floor((Math.random() * 2000));

    init = () => {

        const canvas = document.getElementById(`textCrop_${this.uId}`)
        const {
            width,
            height,
            textureUrl
        } = this.props;

        this.renderer = new THREE.WebGLRenderer({
            canvas,
            alpha: true,
            antialias: true
        });

        this.renderer.setPixelRatio(window.devicePixelRatio);
        this.renderer.setSize(width, height);

        this.scene = new THREE.Scene();

        this.camera = new THREE.PerspectiveCamera(50, width / height, 1, 1000);
        this.camera.position.z = 500;
        this.scene.add(this.camera);

        const loader = new THREE.TextureLoader();
        loader.load(textureUrl, this.textureLoaded);
    }

    getCoords = (x, y) => {
        return [this.startXOffset + this.HtoPxKoef * x, this.startYOffset - this.HtoPxKoef * y]
    }

    textureLoaded = (texture) => {
        const {
            width,
            height
        } = this.props;

        const WtoHScreen = width / height;
        // при spriteH = 465 и  в экран укладывается ровно 1 штука
        const spriteH = 465;

        this.HtoPxKoef = spriteH / height; // это надо умножить на нужные пиксели

        this.startYOffset = (spriteH / 2);
        this.startXOffset = -((spriteH / 2) * WtoHScreen);

        this.particlesAll = [

        ]

        this.particleCount = 120;
        const particles = new THREE.BufferGeometry()
        const positions = new Float32Array(this.particleCount * 3)
        const scales = new Float32Array(this.particleCount * 1)
        const alpha = new Float32Array(this.particleCount * 1)
        const color = new Float32Array(this.particleCount * 3)
        const rotation = new Float32Array(this.particleCount * 1)

        // now create the individual particles
        for (var p = 0; p < this.particleCount; p++) {

            this.particlesAll.push({
                x: 0, y: 0, xForce: 0, yForce: 0, radius: 0, color: null, rotate: 0, lifeTime: 0
            })

            const p3 = p * 3;

            positions[p3] = Math.random() * 300;
            positions[p3 + 1] = 0;
            positions[p3 + 2] = 0;

            color[p3] = Math.random();
            color[p3 + 1] = 0;
            color[p3 + 2] = 0;

            scales[p] = 1 + Math.random();
            alpha[p] = 1;
            rotation[p] = 0;

        }

        // const cd = this.getCoords(100, 100);

        // positions[0] = cd[0];
        // positions[1] = cd[1];

        particles.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        particles.setAttribute('aScale', new THREE.BufferAttribute(scales, 1))
        particles.setAttribute('aAlpha', new THREE.BufferAttribute(alpha, 1))
        particles.setAttribute('aColor', new THREE.BufferAttribute(color, 3))
        particles.setAttribute('aRotation', new THREE.BufferAttribute(rotation, 1))

        this.testMaterial = new THREE.ShaderMaterial({
            depthWrite: false,
            blending: THREE.AdditiveBlending,
            vertexColors: true,
            vertexShader: `
                    attribute float aScale;
                    attribute vec3 aColor;
                    attribute float aAlpha;
                    attribute float aRotation;

                    varying float vOpacity;
                    varying float vRotation;
                    varying vec3 vColor;

                    void main() 
                    {
                        vOpacity = aAlpha;
                        vRotation = aRotation;
                        vColor = aColor;

                        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
                        gl_PointSize = 20.0 * aScale;
                        gl_Position = projectionMatrix * mvPosition;
                    }
                `,
            fragmentShader: `
                    uniform sampler2D uTexture;

                    varying float vOpacity;
                    varying float vRotation;
                    varying vec3 vColor;

                    void main()
                    {

                        vec2 rotated = vec2(
                            cos(vRotation) * (gl_PointCoord.x - 0.5) + sin(vRotation) * (gl_PointCoord.y - 0.5) + 0.5,
                            cos(vRotation) * (gl_PointCoord.y - 0.5) - sin(vRotation) * (gl_PointCoord.x - 0.5) + 0.5
                        );

                    gl_FragColor = texture2D( uTexture, rotated );
                    gl_FragColor = vec4( gl_FragColor.x * vColor.x, gl_FragColor.y * vColor.y, gl_FragColor.z * vColor.z, gl_FragColor.w * vOpacity );

                    }
                `,

            /* 
            
                                  vec2 rotated = vec2(
                        cos(vRotation) * (gl_PointCoord.x - 0.5) + sin(vRotation) * (gl_PointCoord.y - 0.5) + 0.5,
                        cos(vRotation) * (gl_PointCoord.y - 0.5) - sin(vRotation) * (gl_PointCoord.x - 0.5) + 0.5
                    );

                    gl_FragColor = texture2D( uTexture, rotated );
                    gl_FragColor = vec4( gl_FragColor.x * vColor.x, gl_FragColor.y * vColor.y, gl_FragColor.z * vColor.z, gl_FragColor.w * vOpacity );
            
            */

            // gl_FragColor = vec4( gl_FragColor.x, gl_FragColor.y, gl_FragColor.z, vOpacity );

            uniforms: {
                uTime: { value: 0 },
                uTexture: { value: texture },
            }
        })

        this.points = new THREE.Points(particles, this.testMaterial)
        this.scene.add(this.points)

        this.renderer.render(this.scene, this.camera);

        this.tick();
    }

    tick = () => {

        const positions = new Float32Array(this.particleCount * 3)
        const scales = new Float32Array(this.particleCount * 1)
        const alpha = new Float32Array(this.particleCount * 1)
        const color = new Float32Array(this.particleCount * 3)
        const rotation = new Float32Array(this.particleCount * 1)
        for (var p = 0; p < this.particleCount; p++) {

            const innerParticle = this.particlesAll[p];
            innerParticle.lifeTime--;

            if (innerParticle.lifeTime < 0) {
                alpha[p] = 0;
                continue;
            }

            if (this.particlesAll[p].xForce > 0) this.particlesAll[p].xForce -= 0.3;
            if (this.particlesAll[p].yForce > 0) this.particlesAll[p].yForce -= 0.3;

            this.particlesAll[p].x += this.particlesAll[p].xForce;
            this.particlesAll[p].y += this.particlesAll[p].yForce;

            this.particlesAll[p].rotate += Math.random() * 3;

            const { x, y, scale, color: innerColor, rotate, lifeTime, innerLifeTime } = innerParticle;
            const p3 = p * 3;


            const cd = this.getCoords(x, y);
            positions[p3] = cd[0];
            positions[p3 + 1] = cd[1];
            positions[p3 + 2] = 0;

            color[p3] = innerColor[0];
            color[p3 + 1] = innerColor[1];
            color[p3 + 2] = innerColor[2];

            scales[p] = scale;
            alpha[p] = lifeTime / innerLifeTime;
            rotation[p] = rotate;

        }

        this.points.geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        this.points.geometry.setAttribute('aScale', new THREE.BufferAttribute(scales, 1))
        this.points.geometry.setAttribute('aAlpha', new THREE.BufferAttribute(alpha, 1))
        this.points.geometry.setAttribute('aColor', new THREE.BufferAttribute(color, 3))
        this.points.geometry.setAttribute('aRotation', new THREE.BufferAttribute(rotation, 1))

        this.renderer.render(this.scene, this.camera);
        window.requestAnimationFrame(this.tick)
    }

    // добавляем частицы нужные нам
    addParticles = (particlesAdded) => {

        // this.particlesAll.push({
        //     x: 0, y: 0, xForce: 0, yForce: 0, radius: 0, color: null, rotate: 0, lifeTime: 0
        // })

        let nowParticleIndex = 0;

        for (let i = 0; (i < this.particleCount) && (nowParticleIndex < particlesAdded.length); i++) {
            // const { x, y, xForce, yForce, radius, color, rotate, lifeTime } = 
            if (this.particlesAll[i].lifeTime > 0) { continue; }
            this.particlesAll[i] = { ...particlesAdded[nowParticleIndex], innerLifeTime: particlesAdded[nowParticleIndex].lifeTime };
            nowParticleIndex++;
        }

    }

    componentDidMount = () => {
        this.init();
    }

    render() {
        const { width, height, top = 0, left = 0, zIndex = 1 } = this.props;
        return <canvas style={{
            position: 'absolute',
            top, left,
            width, height,
            zIndex
        }} id={`textCrop_${this.uId}`}></canvas>
    }

}